import { useConfigurationFilters } from "../../../../hooks/useConfigurationFilters";
import { Market, Workspace } from "../../../../../../types/workspace";
import { CompanyFilter } from "../../../../../../legacy/types/companyFilter";

export const useConfigurationFiltersWithMatch = (
  workspace: Workspace | undefined,
  selectedMarket: Market
): Partial<CompanyFilter> => {
  const filters = useConfigurationFilters(workspace, selectedMarket) || {};
  const workspaceWhitespace = workspace?.configuration.whitespace;

  return workspaceWhitespace?.fileId && workspaceWhitespace?.lastMatched
    ? {
        ...filters,
        companyMatch: workspaceWhitespace,
      }
    : filters;
};
